import trashCan from '@ingka/ssr-icon/paths/trash-can';
import pencil from '@ingka/ssr-icon/paths/pencil';
import lock from '@ingka/ssr-icon/paths/lock';
import creditCard from '@ingka/ssr-icon/paths/credit-card';
import person from '@ingka/ssr-icon/paths/person';
import deliveryTruck from '@ingka/ssr-icon/paths/delivery-truck';
import home from '@ingka/ssr-icon/paths/home';
import box from '@ingka/ssr-icon/paths/box';
import board from '@ingka/ssr-icon/paths/board';
import points from '@ingka/ssr-icon/paths/reward';
import documentPencil from '@ingka/ssr-icon/paths/document-pencil';

import ListView, { ListViewItem } from '@ingka/list-view';
import Text from '@ingka/text';

import { PREFIX } from '../../Skapa/constants/constants';
import { MenuData, MenuLinkInfo } from './menu-types';

import styles from './Menu.module.scss';
import { LogoutButton } from './LogoutButton/LogoutButton';

function iconTypeToIcon(icon: MenuLinkInfo['icon']) {
  switch (icon) {
    case 'board':
      return board;
    case 'document-pencil':
      return documentPencil;
    case 'box':
      return box;
    case 'delivery-truck':
      return deliveryTruck;
    case 'home':
      return home;
    case 'credit-card':
      return creditCard;
    case 'lock':
      return lock;
    case 'pencil':
      return pencil;
    case 'person':
      return person;
    case 'points':
      return points;
    case 'trash-can':
      return trashCan;
    default:
      console.warn('missing icon for icon name: ', icon);
      return undefined;
  }
}

const Child = ({ model }: { model: MenuLinkInfo }) => (
  <ListViewItem
    emphasised
    inset
    key={model.title}
    prefix={PREFIX}
    title={model.title}
    description={model.subtitle}
    control="link"
    leadingIcon={iconTypeToIcon(model.icon)}
    href={model.href}
    controlIcon="chevronRightSmall"
    className={styles.listViewItem}
  />
);

export function MenuLoggedIn({ menu, onLoggedOut }: Readonly<{ menu: MenuData; onLoggedOut?: () => void }>) {
  return (
    <div className={styles.wrapper}>
      <Text prefix={PREFIX} tagName="h1" headingSize="m" className={styles.heading}>
        {menu.greeting}
      </Text>
      <nav>
        <ListView
          id="main-page-navigation"
          prefix={PREFIX}
          size="medium"
          className={styles.listView}
          showDivider={false}
        >
          {menu.links.map((x) => (
            <Child key={x.title} model={x} />
          ))}

          <LogoutButton onLoggedOut={onLoggedOut} />
        </ListView>
      </nav>
    </div>
  );
}
